import { userRoles } from "../../../app/config";
import { userStatuses } from "../../../app/config/userStatuses";
import {format} from "../../../utils/timeZoneUtils";

export const infoFieldsArray = [
    {
        name: 'id',
        hideOnCreate: true,
    },
    {
        name: 'createdAt',
        hideOnCreate: true,
        convert: (value) => format(value)
    },
    {
        name: 'isBlocked',
        items: userStatuses
    },
    {
        name: 'email',
        modelName: 'Email',
    },
    {
        name: 'firstname',
        modelName: 'Firstname',
    },
    {
        name: 'lastname',
        modelName: 'Lastname',
    },
    // {
    //     name: 'role',
    //     modelName: 'Role',
    //     onlyForAdmin: true,
    //     items: userRoles
    // },
];